import React from "react";
import FaqHead from "../../HomePage/Faq/FaqHead";
import HrdFaqMain from "./HrdFaqMain";

const HrdFaq = () => {
  return (
    <div className="faqContainer">
      <div className="faqContent">
        <FaqHead heading="HRD Attestation Service in Bangalore " />
        <HrdFaqMain />
      </div>
    </div>
  );
};

export default HrdFaq;
